import React from "react"
// import { usePOIStore } from "../State/activePOIStore"
import { useStore } from "../State/Store"
import { AptModalBackdrop } from "./ApartmentCard.style"
import { PoiModal } from "./POI.style"

const text = {
  coronationgardens: "CORONATION GARDENS",
  "allotment-image": "OLIVER ROAD ALLOTMENTS",
  "leyton-orient-image": "HOME OF LEYTON ORIENT F.C",
  "img-1a": "AUCKLAND ROAD",
  "img-1b": "CORONATION SQUARE",
  "img-1c": "CORONATION SQUARE",
  "img-1d": "RESIDENTS PODIUM GARDEN AND PLAY AREA",
  "img-1e": "PUBLIC GARDEN AND PLAY AREA"
}
function POI() {
  const PoiActive = useStore(state => state.PoiActive)
  const setPoiActive = useStore(state => state.setPoiActive)
  const poiID = useStore(state => state.poiID)

  if (PoiActive) {
    return (
      <AptModalBackdrop onClick={() => setPoiActive(false)}>
        <PoiModal>
          <img
            style={{ height: "100%" }}
            src={`${process.env.PUBLIC_URL}/assets/textures/gallery/${
              poiID.split("_")[0] === "two" ? "coronation_square" : "lifestyle"
            }/${poiID.split("_")[1]}.jpg`}
            alt="poiID"
          ></img>
          <div
            style={{
              display: "inline-block",
              zIndex: 4000,
              left: 0,
              bottom: 0,
              position: "absolute",
              width: "max-content",
              // transform: "translate(10%, 20%)",
              //   height: "5vh",
              padding: "0% 1%",
              backgroundColor: "rgba(100,100,100,0.7)"
            }}
          >
            <p
              style={{
                fontFamily: "NotoSans-Regular",
                color: "#F5F5F5",
                letterSpacing: "3px",
                fontSize: "1rem"
              }}
            >
              {text[poiID.split("_")[1]]}
            </p>
          </div>
        </PoiModal>
      </AptModalBackdrop>
    )
  } else return null
}

export default POI
